module.exports = new Promise((resolve, reject) => {
      const urlParams = new URLSearchParams(window.location.search);
      const resolvedHost = urlParams.get('panelSummary') ?? 'https://panel-summary.thoughtriver.com';
      console.log('panelSummary', 'Resolved host:', resolvedHost);
      const resolvedUrl = `${resolvedHost}/remoteEntry.js`;

      const script = document.createElement('script');
      script.src = resolvedUrl;
      script.onload = () => {
        const proxy = {
          get: (request) => window['panelSummary'].get(request),
          init: (...args) => {
            try {
              return window['panelSummary'].init(...args);
            } catch (e) {
              console.log('Remote container already initialized');
            }
          },
        }
        resolve(proxy);
      }

      document.head.appendChild(script);
    });